"use client";

import Image from "next/image";
import Reveal from "./Reveal";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

export default function SolutionSection() {
  const t = useTranslations("enterprise");
  const data = [
    {
      content: t("high-throughput-for-continuous-model-updates-and-inference"),
      imgUrl: "/images/icons/infinity.png",
    },
    {
      content: t("zkml-runtime-for-data-integrity-without-exposing-raw-data"),
      imgUrl: "/images/icons/lock.png",
    },
    {
      content: t("deterministic-micro-payment-settlements-for-compute-work"),
      imgUrl: "/images/icons/clock.png",
    },
    {
      content: t(
        "federated-orchestration-to-integrate-ai-across-enterprises-seamlessly",
      ),
      imgUrl: "/images/icons/chain.png",
    },
  ];

  return (
    <section className="py-20">
      <div className="flex flex-col items-center justify-center">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h2 className="max-w-[800px] text-center text-[48px]/[56px] tracking-[-1px] text-[#202020] max-lg:max-w-[410px] max-lg:text-[32px]/[40px]">
            {t("the-sovereign")}{" "}<br/>
            <span className="text-[#06f]">{t("blockchain-backbone")}</span>{" "}<br/>
            {t("for-ai")}
          </h2>
        </Reveal>
        <Reveal
          delay={0.5}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mt-6 text-base/[24px] font-light text-[#646464]">
            {t("a-blockchain-designed-for-ai-workloads-at-scale")}
          </p>
        </Reveal>
        <p className="mb-4 mt-14 font-open-sans text-base font-normal text-[#06f] max-lg:mt-10">
          It delivers
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="flex flex-col items-center justify-center gap-[14px] max-lg:px-10 max-sm:px-4">
          {data.map((item, index) => (
            <div
              key={index}
              className="flex w-[800px] items-center justify-between gap-4 rounded-[24px] border-[2px] border-[#E9F3FF] bg-[#F3F8FF61] p-6 max-lg:w-full max-lg:py-3 max-sm:flex-col-reverse max-sm:text-center"
            >
              <p className="text-[22px]/[30px] tracking-[-0.5px] text-[#202020] max-lg:text-lg">
                {item.content}
              </p>
              <div className="relative h-[122px] w-[140px] max-lg:h-[75px] max-lg:w-[80px] max-sm:h-[122px] max-sm:w-[130px]">
                <Image src={item.imgUrl} alt={item.content} fill />
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
